import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealPartnerAssignment } from "~/models/DealPartnerAssignment";
import { generatePath } from "~/utils/generatePath";

export const useDealPartnerAssignmentLatest = (
	dealId: number
): SwrReturnType<DealPartnerAssignment> => {
	const { data, mutate, error, isLoading } = useSWR<DealPartnerAssignment>(
		generatePath("/vendors/deals/:deal_id/deal_partner_assignment/latest", {
			deal_id: dealId
		})
	);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
